
"use strict";

const isArray = exports.isArray = require('node-tools/js/util').isArray;
const co = require('co');
const hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * map collection
 *
 * NOTE: this function is not compatible with Array.prototype.map
 *
 * @param {Array} collection
 * @param {function} iterator(item, index)
 * @return {Array}
**/
exports.map = function(collection, iterator) {
  var ret = [];
  for(var i = 0, len = collection.length; i < len; ++i ) {
    ret.push(iterator(collection[i], i));
  }
  return ret;
};

/**
 * create new collection with removed all nulls and undefined values
 *
 * @param {Array} collection
 * @return {Array}
**/
exports.compact = function compact(collection) {
  var ret = [];
  for(var item, i = 0, len = collection.length; i < len; ++i ) {
    item = collection[i];
    if (item != null) ret.push(item);
  }
  return ret;
};

/**
 * iterate through collection
 *
 * NOTE: this function is not compatible with Array.prototype.forEach
 *
 * @param {Array} collection
 * @param {function} iterator(item, index)
**/
exports.each = function(collection, iterator) {
  for(var i = 0, len = collection.length; i < len; ++i ) {
    iterator(collection[i], i);
  }
};

/**
 * throw array of Promises 
 *
 * @param {Array} collection
 * @param {function} generator(item, index)
**/
exports.promises = function(collection, generator) {
  if (generator.constructor.name !== "GeneratorFunction")
    throw new Error('wrong GeneratorFunction in promises collection');
  const arr = [];

  for (let i=0; i<collection.length; i++) {
    const promise = co.wrap( generator );
    arr.push(promise(collection[i], i));
  }
  // return pending Promise
  return arr; // promises are starting to resolve immediately
};

/**
 * make a Promise from GeneratorFunction
 *
 * @param {function} generator
**/
const promise = exports.promise = function(generator) {
  if (generator.constructor.name !== "GeneratorFunction")
    throw new Error('wrong GeneratorFunction in promises collection');

  const promise = co.wrap( generator );
  // return Promise function
  return promise; // this promise needs to be call 'promise()'
};



/**
 * make a chain of promises from (array and generator) 
 *
 * @param {Array} collection
 * @param {function} generator
**/
exports.promiseChain = function(collection, generator) {
  if (generator.constructor.name !== "GeneratorFunction")
    throw new Error('wrong GeneratorFunction in promises collection');
  // if (collection.length <= 0)
  //   throw new Error('collection length must be more then 0');

  const func = function* () {
    for (let i=0; i<collection.length; i++) {
      yield generator(collection[i]);
    }
  }

  return promise(func);
};



/**
 * find element inside collection
 *
 * NOTE: this function is not compatible with Array.prototype.find
 *
 * @param {Array} collection
 * @param {function} iterator(item, index) -> boolean
 * @return {*} array item found or undefined
**/
exports.find = function(collection, iterator) {
  var item;
  for(var i = 0, len = collection.length; i < len; ++i ) {
    item = collection[i];
    if (item !== void(0) && iterator(item, i))
      return item;
  }
};

/**
 * deeply compare objects
 *
 * NOTE: this function assumes that deeply compared objects may differ in values rather than in keys
 *
 * @param {*} a
 * @param {*} b
 * @return {boolean}
**/
var deepCompareSimilar = exports.deepCompareSimilar = function(a, b) {
  if (a === b)
    return true;
  if (a && b && 'object' === typeof a && 'object' === typeof b) {
    for(var key in a) {
      if (!deepCompareSimilar(a[key], b[key]))
        return false;
    }
    return true;
  }
  return false;
};

/**
 * map collection in reverse order
 *
 * NOTE: output is a reversed map of input
 *
 * @param {Array} collection
 * @param {function} iterator(item, index)
 * @return {Array}
**/
exports.reverseMap = function(collection, iterator) {
  var ret = [];
  for(var i = collection.length; i-- > 0; ) {
    ret.push(iterator(collection[i]));
  }
  return ret;
};

/**
 * iterate through collection in reverse order
 *
 * @param {Array} collection
 * @param {function} iterator(item, index)
**/
exports.reverseEach = function(collection, iterator) {
  for(var i = collection.length; i-- > 0; ) {
    iterator(collection[i]);
  }
};

/**
 * Return true if every invokation on each collection item is truish
 *
 * NOTE: this function is not compatible with Array.prototype.every and iterates in reverse order
 *
 * @param {Array} collection
 * @param {function} iterator(item, index)
 * @return {Array}
**/
exports.every = function(collection, iterator) {
  for(var i = collection.length; i-- > 0; ) {
    if (!iterator(collection[i], i))
      return false;
  }
  return true;
};

/**
 * deeply copy the values of all enumerable own properties
 *
 * @param {*} object
 * @return {*} object
**/
exports.deepCopy = function(object) {
  if (object !== null && 'object' === typeof object) {
    return isArray(object) ? deepExtendArray([], object)
                           : deepExtend({}, object);
  } else return object;
};

/**
 * deeply extend the values of all enumerable own properties
 *
 * @param {Object} target
 * @param {Object} source
 * @return target
**/
exports.deepExtend = deepExtend;

function deepAssign(target, key, value) {
  if (isArray(value)) {
    deepExtendArray(target[key] = [], value);
  } else if (value !== null && 'object' === typeof value) {
    deepExtend(target[key] = {}, value);
  } else {
    target[key] = value;
  }
}

function deepExtendArray(target, array) {
  var i = target.length = array.length;
  while(i-- > 0) {
    if (i in array) {
      deepAssign(target, i, array[i]);
    }
  }
  return target;
}

function deepExtend(target, source) {
  for(var key in source) {
    if (hasOwnProperty.call(source, key)) {
      deepAssign(target, key, source[key]);
    }
  }
  return target;
}

/**
 * copy the values of all enumerable own properties from one or more source objects to a target object
 *
 * @param {Array} target
 * @param {Array} ...sources
 * @return {Array} target
**/
exports.assign = ('function' === typeof Object.assign) ? Object.assign : function(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  target = Object(target);
  for (var index = 1, len = arguments.length; index < len; ++index) {
    var source = arguments[index];
    if (source != null) {
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
  }
  return target;
};
